module.exports = __webpack_public_path__ + "static/media/hearts_8.d7e82c70.png";